import {Navigate} from 'react-router-dom';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {FarmEvents} from 'utilities/helper/googleAnalitics/EventHelper';
export const ProtectedRoute = ({children}: ProtectedRouteProps) => {
  const user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user') || '')
    : null;
  const intro = localStorage.getItem('intro');

  if (!user) {
    if (intro) {
      return <Navigate to="/auth/login" />;
    }
    return <Navigate to="/auth/introduction" />;
  }
  if (user) {
    googleAnalyticsInstance.eventGoogleAnalytics(FarmEvents.login);
  }
  return children;
};
